import ResourcePublisherQuery from "@pathwright/web/src/modules/resource/graphql/ResourcePublisherQuery"
import PropTypes from "prop-types"

const StepContentAttribution = ({ school, publisher }) => (
  <div
    style={{
      position: "absolute",
      top: 0,
      left: "50%",
      fontSize: 12,
      borderRadius: 20,
      padding: "2px 5px",
      color: "#888",
      background: "white",
      border: "1px solid rgba(0,0,0,0.1)",
      transform: "translate3d(-50%,-50%,0)",
      WebkitTransform: "translate3d(-50%,-50%,0)",
      zIndex: 999999999
    }}
  >
    {publisher
      ? `Content © ${new Date().getFullYear()} ${publisher.name}`
      : school
      ? `Added by ${school.name}`
      : null}
  </div>
)

const StepContentAttributionContainer = (
  { children, isEditing, isLocalContent },
  { school }
) => {
  return (
    <div
      style={
        isEditing
          ? {
              padding: 30,
              background: "#ddd"
            }
          : {
              borderTop: "1px solid rgba(0,0,0,0.1)"
            }
      }
    >
      {isLocalContent ? (
        <StepContentAttribution school={school} />
      ) : (
        <ResourcePublisherQuery
          id={App.getStore("resource").get("resource").id}
        >
          {({ publisher }) =>
            publisher && <StepContentAttribution publisher={publisher} />
          }
        </ResourcePublisherQuery>
      )}
      <div style={{ background: "white", paddingTop: 20 }}>{children}</div>
    </div>
  )
}

StepContentAttributionContainer.displayName = "StepContentAttributionContainer"

StepContentAttributionContainer.contextTypes = {
  school: PropTypes.object.isRequired
}

export default StepContentAttributionContainer
